import { SvgIcon } from "@material-ui/core";
import React from "react";

const NotificationIcon = (props) => {
  return (
    <SvgIcon
      style={{
        fontSize: 24,
      }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.38 35.36">
        <path d="M33.13,10.31H28.57L23.36,5.1A13.26,13.26,0,0,0,8,2.59L6.52,1.16A3.85,3.85,0,0,0,1.24,1,3.78,3.78,0,0,0,1.1,6.42L2.6,7.91A12.9,12.9,0,0,0,4.86,23.08l5.47,5.47v4.56a2.25,2.25,0,0,0,3.83,1.59L34.72,14.14A2.24,2.24,0,0,0,33.13,10.31Z" />
        <path d="M30.8,22.41l-8.36,8.37a1.28,1.28,0,0,0,.23,2A7.33,7.33,0,0,0,32.79,22.65,1.28,1.28,0,0,0,30.8,22.41Z" />
      </svg>
    </SvgIcon>
  );
};

export default NotificationIcon;
